(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-flexible"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-us-flexible')) {
    customElements.define('about-us-flexible', class extends HTMLElement {
      connectedCallback() {
        this.frameRequest = requestAnimationFrame(() => this.setupReveal());
      }
      setupReveal() {
        const target = this.querySelector('[data-reveal-target]');
        if (!target || this.dataset.reveal !== 'true' || !('IntersectionObserver' in window) || !target.animate) return;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = () => {
          if (this.motionQuery.matches && this.animation) this.animation.cancel();
        };
        this.motionQuery.addEventListener('change', this.onMotionChange);
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (!this.motionQuery.matches) {
                if (this.animation) this.animation.cancel();
                this.animation = target.animate([
                  { opacity: 0 },
                  { opacity: 1 }
                ], {
                  duration: Number(this.dataset.duration) || 1000,
                  delay: Number(this.dataset.delay) || 0,
                  easing: this.dataset.easing || 'ease-in-out',
                  fill: 'backwards'
                });
              }
              if (this.dataset.repeat !== 'true') this.observer.unobserve(target);
            } else if (this.animation) {
              this.animation.cancel();
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
        this.observer.observe(target);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frameRequest);
        if (this.observer) this.observer.disconnect();
        if (this.animation) this.animation.cancel();
        if (this.motionQuery && this.onMotionChange) this.motionQuery.removeEventListener('change', this.onMotionChange);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-us-vertical"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-us-vertical')) {
    customElements.define('about-us-vertical', class extends HTMLElement {
      connectedCallback() {
        this.frameRequest = requestAnimationFrame(() => this.setupReveal());
      }
      setupReveal() {
        const target = this.querySelector('[data-reveal-target]');
        if (!target || this.dataset.reveal !== 'true' || !('IntersectionObserver' in window) || !target.animate) return;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = () => {
          if (this.motionQuery.matches && this.animation) this.animation.cancel();
        };
        this.motionQuery.addEventListener('change', this.onMotionChange);
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (!this.motionQuery.matches) {
                if (this.animation) this.animation.cancel();
                this.animation = target.animate([
                  { opacity: 0 },
                  { opacity: 1 }
                ], {
                  duration: Number(this.dataset.duration) || 1000,
                  delay: Number(this.dataset.delay) || 0,
                  easing: this.dataset.easing || 'ease-in-out',
                  fill: 'backwards'
                });
              }
              if (this.dataset.repeat !== 'true') this.observer.unobserve(target);
            } else if (this.animation) {
              this.animation.cancel();
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
        this.observer.observe(target);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frameRequest);
        if (this.observer) this.observer.disconnect();
        if (this.animation) this.animation.cancel();
        if (this.motionQuery && this.onMotionChange) this.motionQuery.removeEventListener('change', this.onMotionChange);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-header-in-fixed-1"] && !Shopify.designMode) return;
  try {
    
  class FloatingHeader extends HTMLElement {
    connectedCallback() {
      this.menuToggle = this.querySelector('[data-fh-menu-toggle]');
      this.panel = this.querySelector('[data-fh-panel]');
      this.searchToggle = this.querySelector('[data-fh-search-toggle]');
      this.searchPanel = this.querySelector('[data-fh-search-panel]');
      this.searchInput = this.querySelector('[data-fh-search-input]');
      this.musicToggle = this.querySelector('[data-fh-music-toggle]');
      this.audio = this.querySelector('[data-fh-audio]');
      this.cartBubble = this.querySelector('[data-fh-cart-bubble]');

      this.setupTicker();

      if (this.menuToggle && this.panel) {
        this.menuToggle.addEventListener('click', () => this.toggleMenu());
      }

      if (this.searchToggle && this.searchPanel) {
        this.searchToggle.addEventListener('click', () => this.toggleSearch());
      }

      this.querySelectorAll('[data-fh-submenu-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => this.toggleSubmenu(btn));
      });

      if (this.musicToggle) {
        this.musicToggle.addEventListener('click', () => this.toggleMusic());

        if (this.musicToggle.getAttribute('aria-pressed') === 'true') {
          const startOnInteraction = () => {
            this.playMusic();
            document.removeEventListener('pointerdown', startOnInteraction);
          };
          document.addEventListener('pointerdown', startOnInteraction, { once: true });
        }
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeMenu();
          this.closeSearch();
        }
      });

      document.addEventListener('click', (event) => {
        if (this.contains(event.target)) return;
        if (this.getAttribute('data-fh-open') === 'true') this.closeMenu();
        if (this.getAttribute('data-fh-search-open') === 'true') this.closeSearch();
      });

      this.setupCartSync();
    }

    disconnectedCallback() {
      if (this.tickerResizeObserver) this.tickerResizeObserver.disconnect();
    }

    setupTicker() {
      this.tickerTrack = this.querySelector('[data-fh-ticker-track]');
      this.tickerGroup = this.querySelector('[data-fh-ticker-group]');
      if (!this.tickerTrack || !this.tickerGroup) return;

      const buildTicker = () => {
        this.tickerTrack.setAttribute('data-fh-ticker-ready', 'false');

        while (this.tickerTrack.children.length > 1) {
          this.tickerTrack.lastElementChild.remove();
        }

        const originalItem = this.tickerGroup.firstElementChild;
        if (!originalItem) return;

        while (this.tickerGroup.children.length > 1) {
          this.tickerGroup.lastElementChild.remove();
        }

        const tickerWidth = this.tickerTrack.parentElement.clientWidth;
        while (this.tickerGroup.scrollWidth < tickerWidth + originalItem.offsetWidth) {
          const repeatedItem = originalItem.cloneNode(true);
          repeatedItem.setAttribute('aria-hidden', 'true');
          this.tickerGroup.appendChild(repeatedItem);
        }

        const duplicateGroup = this.tickerGroup.cloneNode(true);
        duplicateGroup.removeAttribute('data-fh-ticker-group');
        duplicateGroup.setAttribute('aria-hidden', 'true');
        this.tickerTrack.appendChild(duplicateGroup);

        this.tickerTrack.setAttribute('data-fh-ticker-ready', 'true');
      };

      requestAnimationFrame(buildTicker);
      this.tickerResizeObserver = new ResizeObserver(buildTicker);
      this.tickerResizeObserver.observe(this.tickerTrack.parentElement);
    }

    toggleMenu() {
      const isOpen = this.getAttribute('data-fh-open') === 'true';
      if (isOpen) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    }

    openMenu() {
      this.closeSearch();
      this.setAttribute('data-fh-open', 'true');
      this.menuToggle.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
    }

    closeMenu() {
      this.setAttribute('data-fh-open', 'false');
      if (this.menuToggle) this.menuToggle.setAttribute('aria-expanded', 'false');
      if (this.panel) this.panel.hidden = true;
    }

    toggleSearch() {
      const isOpen = this.getAttribute('data-fh-search-open') === 'true';
      if (isOpen) {
        this.closeSearch();
      } else {
        this.openSearch();
      }
    }

    openSearch() {
      this.closeMenu();
      this.setAttribute('data-fh-search-open', 'true');
      if (this.searchToggle) this.searchToggle.setAttribute('aria-expanded', 'true');
      if (this.searchPanel) this.searchPanel.hidden = false;
      requestAnimationFrame(() => {
        if (this.searchInput) this.searchInput.focus();
      });
    }

    closeSearch() {
      this.setAttribute('data-fh-search-open', 'false');
      if (this.searchToggle) this.searchToggle.setAttribute('aria-expanded', 'false');
      if (this.searchPanel) this.searchPanel.hidden = true;
    }

    toggleSubmenu(btn) {
      const targetId = btn.getAttribute('aria-controls');
      const submenu = this.querySelector('#' + CSS.escape(targetId));
      if (!submenu) return;
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      submenu.hidden = isOpen;
    }

    toggleMusic() {
      const isOn = this.musicToggle.getAttribute('aria-pressed') === 'true';
      if (isOn) {
        this.stopMusic();
      } else {
        this.playMusic();
      }
    }

    playMusic() {
      if (!this.audio) return;
      this.audio.play().catch(() => {});
      this.musicToggle.setAttribute('aria-pressed', 'true');
      this.setAttribute('data-fh-music-on', 'true');
    }

    stopMusic() {
      if (!this.audio) return;
      this.audio.pause();
      this.audio.currentTime = 0;
      this.musicToggle.setAttribute('aria-pressed', 'false');
      this.setAttribute('data-fh-music-on', 'false');
    }

    // ---- Cart count sync -------------------------------------------------
    // Keeps the header cart bubble in sync with the real cart, without a
    // page refresh, no matter which mechanism added the item (theme's
    // native add-to-cart, quick add, a cart drawer app, etc).
    //
    // We don't rely on a single mechanism because theme/app internals vary
    // and change between versions. Instead we stack several independent
    // detection layers; any one of them firing is enough to trigger a
    // re-check against /cart.js (the actual source of truth).
    setupCartSync() {
      if (!this.cartBubble) return;

      // 1) Listen to the common cart events used across Shopify themes
      //    (Horizon's own events + the newer "standard storefront events").
      //    We don't trust the payload shape (it's inconsistent across theme
      //    versions) — we just use the event as a signal to re-check.
      const cartEventNames = [
        'cart:update',
        'cart:updated',
        'cart:change',
        'cart:refresh',
        'cart:build',
        'shopify:cart:update',
        'shopify:cart:lines-update',
        'shopify:cart:view'
      ];
      cartEventNames.forEach((name) => {
        document.addEventListener(name, () => this.refreshCartCount());
      });

      // 2) Native DOM signal that can't be "missed": every standard Shopify
      //    add-to-cart form fires a real `submit` event, regardless of what
      //    JS (if any) intercepts it afterwards. Listening in the capture
      //    phase means we see it even if another script stops propagation.
      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        const action = form.getAttribute('action') || '';
        if (/\/cart\/add/i.test(action) || form.querySelector('[name="add"]')) {
          this.scheduleCartRecheck();
        }
      }, true);

      // 3) Click-based heuristic: covers "quick add" buttons that aren't
      //    inside a <form> (e.g. on collection/product cards). `name="add"`
      //    is the standard attribute Shopify themes use on the add-to-cart
      //    submit button, so this is safe to key off broadly.
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest(
          '[name="add"], [data-add-to-cart], [data-atc], [data-quick-add-submit]'
        );
        if (trigger) this.scheduleCartRecheck();
      }, true);

      // 4) Safety net: catch the underlying AJAX call itself
      //    (/cart/add.js, /cart/change.js, ...) whether it's made with
      //    fetch or XMLHttpRequest, in case none of the above catch it.
      document.addEventListener('floating-header:cart-fetch-sync', () => this.refreshCartCount());
      this.patchFetchForCartSync();
      this.patchXhrForCartSync();

      // 5) Re-check when the page is restored from the back/forward cache,
      //    so the bubble doesn't show a stale count after navigating back.
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.refreshCartCount();
      });

      // Initial sync in case the server-rendered count is already stale
      // (e.g. page served from an intermediary cache).
      this.refreshCartCount();
    }

    // We often don't know exactly when an async add-to-cart request will
    // resolve, so re-check a few times over ~2 seconds instead of guessing
    // a single delay. Cheap, and guarantees eventual consistency.
    scheduleCartRecheck() {
      [250, 700, 1500].forEach((delay) => {
        setTimeout(() => this.refreshCartCount(), delay);
      });
    }

    patchFetchForCartSync() {
      if (window.__fhCartFetchPatched) return;
      window.__fhCartFetchPatched = true;

      const originalFetch = window.fetch.bind(window);
      const cartEndpointPattern = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

      window.fetch = (...args) => {
        const input = args[0];
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const promise = originalFetch(...args);

        if (cartEndpointPattern.test(url)) {
          promise
            .then((response) => {
              if (response && response.ok) {
                document.dispatchEvent(new CustomEvent('floating-header:cart-fetch-sync'));
              }
            })
            .catch(() => {});
        }

        return promise;
      };
    }

    patchXhrForCartSync() {
      if (window.__fhCartXhrPatched) return;
      window.__fhCartXhrPatched = true;

      const cartEndpointPattern = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
      const originalOpen = XMLHttpRequest.prototype.open;
      const originalSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url, ...rest) {
        this.__fhIsCartRequest = typeof url === 'string' && cartEndpointPattern.test(url);
        return originalOpen.call(this, method, url, ...rest);
      };

      XMLHttpRequest.prototype.send = function (...args) {
        if (this.__fhIsCartRequest) {
          this.addEventListener('load', () => {
            if (this.status >= 200 && this.status < 300) {
              document.dispatchEvent(new CustomEvent('floating-header:cart-fetch-sync'));
            }
          });
        }
        return originalSend.apply(this, args);
      };
    }

    refreshCartCount() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
        .then((res) => res.json())
        .then((cart) => this.updateCartCount(cart.item_count))
        .catch(() => {});
    }

    updateCartCount(count) {
      if (!this.cartBubble) return;
      const safeCount = Math.max(0, parseInt(count, 10) || 0);
      this.cartBubble.textContent = safeCount;
      this.cartBubble.hidden = safeCount === 0;
    }
  }

  if (!customElements.get('floating-header')) {
    customElements.define('floating-header', FloatingHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class HeroAnimationManager {
      constructor() {
        this.init();
        if (Shopify.designMode) {
          document.addEventListener('shopify:section:load', () => this.init());
          document.addEventListener('shopify:block:select', (e) => this.handleEditorBlockSelect(e));
        }
      }

      init() {
        const heroes = document.querySelectorAll('.hero[data-reveal="true"]:not(.reveal-initialized)');
        heroes.forEach(hero => {
          hero.classList.add('reveal-initialized');
          const blocks = hero.querySelectorAll('.hero__content-wrapper > *');
          
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            blocks.forEach(block => block.classList.add('is-revealed'));
            return;
          }

          const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const baseDelay = parseInt(getComputedStyle(hero).getPropertyValue('--anim-delay') || 0);
                blocks.forEach((block, index) => {
                  block.style.transitionDelay = `${baseDelay + (index * 80)}ms`;
                  block.classList.add('is-revealed');
                });
                obs.unobserve(hero);
              }
            });
          }, { threshold: 0.1 });

          observer.observe(hero);
        });
      }

      handleEditorBlockSelect(e) {
        const parentHero = e.target.closest('.hero[data-reveal="true"]');
        if (parentHero) {
          parentHero.querySelectorAll('.hero__content-wrapper > *').forEach(el => {
            el.classList.add('is-revealed');
          });
        }
      }
    }

    new HeroAnimationManager();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mermaid-benefit-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mermaid-benefit-cards')) {
    customElements.define('mermaid-benefit-cards', class extends HTMLElement {
      connectedCallback() {
        this.frameRequest = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.manualPause = this.motionQuery.matches;
        this.button = this.querySelector('.mbc__video-control');
        this.videos = Array.from(this.querySelectorAll('video'));
        if (!this.videos.length) return;
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.onChange = () => this.updateVideo();
        this.mediaQuery.addEventListener('change', this.onChange, options);
        this.motionQuery.addEventListener('change', () => {
          this.manualPause = this.motionQuery.matches;
          this.updateVideo();
        }, options);
        document.addEventListener('visibilitychange', this.onChange, options);
        this.button.addEventListener('click', () => {
          this.manualPause = this.activeVideo && !this.activeVideo.paused;
          this.updateVideo();
        }, options);
        this.videos.forEach(video => {
          video.addEventListener('play', () => this.updateButton(), options);
          video.addEventListener('pause', () => this.updateButton(), options);
        });
        this.inView = !('IntersectionObserver' in window);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.updateVideo();
          });
          this.observer.observe(this);
        }
        this.updateVideo();
      }
      updateButton() {
        if (!this.button) return;
        this.button.hidden = !this.activeVideo;
        this.button.textContent = this.activeVideo && !this.activeVideo.paused ? 'Pause video' : 'Play video';
      }
      updateVideo() {
        const device = this.mediaQuery.matches ? 'mobile' : 'desktop';
        this.activeVideo = this.querySelector('[data-device="' + device + '"] video');
        this.videos.forEach(video => {
          if (video !== this.activeVideo || !this.inView || this.manualPause || document.hidden) {
            video.pause();
            return;
          }
          if (!video.dataset.loaded) {
            video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
            video.dataset.loaded = 'true';
            video.muted = true;
            video.load();
          }
          const result = video.play();
          if (result && result.catch) result.catch(() => this.updateButton());
        });
        this.updateButton();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frameRequest);
        if (this.listeners) this.listeners.abort();
        if (this.observer) this.observer.disconnect();
        if (this.videos) this.videos.forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.password-access__countdown[data-countdown]');
    roots.forEach(function (root) {
      var dateStr = root.getAttribute('data-target-date');
      var timeStr = root.getAttribute('data-target-time') || '00:00';
      var hideOnComplete = root.getAttribute('data-hide-on-complete') === 'true';
      var completeEl = root.querySelector('.password-access__countdown-complete');
      var digitsEl = root.querySelector('.password-access__countdown-digits');
      var liveEl = root.querySelector('.password-access__countdown-live');

      if (!dateStr) {
        return;
      }

      var iso = dateStr + 'T' + timeStr + ':00';
      var target = new Date(iso);

      if (isNaN(target.getTime())) {
        return;
      }

      var valueEls = {
        days: root.querySelector('[data-unit="days"]'),
        hours: root.querySelector('[data-unit="hours"]'),
        minutes: root.querySelector('[data-unit="minutes"]'),
        seconds: root.querySelector('[data-unit="seconds"]')
      };

      var lastMinuteAnnounced = null;
      var timerId = null;

      function pad(n) {
        n = Math.max(0, n);
        return n < 10 ? '0' + n : String(n);
      }

      function render() {
        var now = new Date().getTime();
        var diff = target.getTime() - now;

        if (diff <= 0) {
          if (valueEls.days) valueEls.days.textContent = '00';
          if (valueEls.hours) valueEls.hours.textContent = '00';
          if (valueEls.minutes) valueEls.minutes.textContent = '00';
          if (valueEls.seconds) valueEls.seconds.textContent = '00';

          if (completeEl) {
            completeEl.hidden = false;
          }
          if (hideOnComplete && digitsEl) {
            digitsEl.style.display = 'none';
          }
          if (liveEl && lastMinuteAnnounced !== 'complete') {
            liveEl.textContent = completeEl ? completeEl.textContent : '';
            lastMinuteAnnounced = 'complete';
          }
          if (timerId) {
            clearInterval(timerId);
            timerId = null;
          }
          return;
        }

        var totalSeconds = Math.floor(diff / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        if (valueEls.days) valueEls.days.textContent = pad(days);
        if (valueEls.hours) valueEls.hours.textContent = pad(hours);
        if (valueEls.minutes) valueEls.minutes.textContent = pad(minutes);
        if (valueEls.seconds) valueEls.seconds.textContent = pad(seconds);

        var minuteKey = days + '-' + hours + '-' + minutes;
        if (liveEl && minuteKey !== lastMinuteAnnounced) {
          liveEl.textContent = days + ' days ' + hours + ' hours ' + minutes + ' minutes remaining';
          lastMinuteAnnounced = minuteKey;
        }
      }

      render();
      timerId = setInterval(render, 1000);

      window.addEventListener('beforeunload', function () {
        if (timerId) clearInterval(timerId);
      });
    });

    var toggles = document.querySelectorAll('.password-access__toggle[data-pa-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.password-access__input-wrap');
        if (!wrap) return;
        var input = wrap.querySelector('.password-access__input');
        if (!input) return;
        var isPassword = input.getAttribute('type') === 'password';
        input.setAttribute('type', isPassword ? 'text' : 'password');
        btn.setAttribute('aria-pressed', isPassword ? 'true' : 'false');
        btn.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
